.statusButtons {
    display: flex;
    gap: 0;
    align-items: center;
    flex-shrink: 0;
}

/* Override Mantine ActionIcon to match DibApp2020 sizing */
.statusButtons button {
    width: 2rem;
    height: 2rem;
    min-width: 2rem;
    min-height: 2rem;
    border-radius: 4px;
    padding: 7px;
    margin: 0 0.5rem;
}

.statusButtons button svg {
    width: 18px;
    height: 18px;
}

/* OK button */
.okButton {
    color: #428C37;
}
.okButton:hover {
    background-color: hsla(112, 44%, 38%, 0.1);
}
.okButton.activeButton {
    background-color: #428C37;
    color: white;
}
.okButton.activeButton:hover {
    background-color: hsla(112, 44%, 38%, 0.6);
}

/* Deviation button */
.deviationButton {
    color: hsla(20, 100%, 59%, 1);
}
.deviationButton:hover {
    background-color: hsla(20, 100%, 59%, 0.1);
}
.deviationButton.activeButton {
    background-color: hsla(20, 100%, 59%, 1);
    color: white;
}
.deviationButton.activeButton:hover {
    background-color: hsla(20, 100%, 59%, 0.6);
}

/* NA button */
.naButton {
    color: hsl(0, 86%, 63%);
}
.naButton:hover {
    background-color: hsla(0, 86%, 63%, 0.1);
}
.naButton.activeButton {
    background-color: hsl(0, 86%, 63%);
    color: white;
}
.naButton.activeButton:hover {
    background-color: hsla(0, 86%, 63%, 0.6);
}

.activeButton {
    opacity: 1;
}
